import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__close",
  "use": "general__close-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol stroke-linecap=\"round\" stroke-width=\"3.5\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__close\">\n  <line x1=\"2\" y1=\"2\" x2=\"28\" y2=\"28\" />\n  <line x1=\"28\" y1=\"2\" x2=\"2\" y2=\"28\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol